import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { LOCALSERVICE } from '../utils/constants';

/**
 * This API returns a translation map
 * and return User data
 * @param {number} id
 * @param {string} language
 * @return {Promise<AxiosResponse>}
 */
const getLocalData = (id: number, language: string) =>
  trackPromise(
    axios.post(`${LOCALSERVICE}/getLocalizationMap`, undefined, {
      params: {
        idProgram: id,
        language,
      },
    }),
    id === 1 ? 'app' : 'module',
  );

export default {
  getLocalData,
};
